import React from 'react';

import siteBanner_img from '../assets/img/temp/siteBanner_img_4.jpg';
import siteBanner_img_ov from '../assets/img/temp/siteBanner_img_ov.jpg?v=3';
import siteBanner_img_om from '../assets/img/temp/siteBanner_img_om.jpg';
import siteBanner_img_op from '../assets/img/temp/siteBanner_img_op.jpg?v=3';

import {ContactPlaces, ContactDoctors, ContactGallery} from '../components/index';
import texts from "../texts";

import galleryImgs_ov from "../assets/img/llc/contact/ov";
import galleryImgs_om from "../assets/img/llc/contact/om";
import galleryImgs_op from "../assets/img/llc/contact/op";

class Contact extends React.Component {

  constructor() {
    super();

    this.state = {
      branchActive: 1
    }
  }

  changeActiveTab = (e) => {
    e.preventDefault();

    this.setState({
      branchActive: parseInt(e.target.id)
    })
  };

  renderBgImg = () => {
    if (this.state.branchActive === 1) {
      return (<img src={siteBanner_img_ov} className="siteBanner_bg"/>)
    } else if (this.state.branchActive === 2) {
      return (<img src={siteBanner_img_om} className="siteBanner_bg"/>)
    } else if (this.state.branchActive === 3) {
      return (<img src={siteBanner_img_op} className="siteBanner_bg"/>)
    } else {
      return (<img src={siteBanner_img} className="siteBanner_bg"/>)
    }
  };

  render() {
    return (
      <div>
        <div className="siteBanner siteBanner_docs">
          {this.renderBgImg()}
          <h2 className="line">Kontakt</h2>
        </div>
        <ContactPlaces
          branchActive={this.state.branchActive}
          changeActiveTab={this.changeActiveTab}
          langs={
            {
              footer: texts.langs.footer, main: texts.langs.main
            }
          }
          branches={texts.gen.branches}
        />
        <ContactDoctors
          langs={{
            doctors: this.props.texts.langs.doctors
          }}
          branchActive={this.state.branchActive}
        />
        <ContactGallery
          branchActive={this.state.branchActive}
          galleryImgs_ov={galleryImgs_ov}
          galleryImgs_om={galleryImgs_om}
          galleryImgs_op={galleryImgs_op}
        />
      </div>
    );
  }

}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/Contact.js